<template>
	<page-template>
		<template v-slot:content>
			<common-table
				:title="$t('stocks')"
				:headers="headers"
				showFilter
				:filtered="Boolean(filterDialog.data.text || filterDialog.data.warehouse || filterDialog.data.lotNo)"
				@filter-button-click="filterDialog.show"
				:items="stocksWithNames"
				:items-length="pagination.totalItemCount"
				:items-per-page="tableOptions.itemsPerPage"
				:items-per-page-options="tableFooterProps.itemsPerPageOptions"
				:options.sync="tableOptions"
				:loading="loading"
				:entity-name="$t('stock')"
				:buttonText="$t('add_item', { item: $t('stocks') })"
				@row-click="stockAction"
				@button-click="newStock"
			>
				<template #publicButton>
					<v-btn v-if="company && company.publicUrl" class="my-4" outlined color="primary" @click="goToPublicAddress">
						<v-icon class="pr-2">icon-public</v-icon>
						{{ $t("show_company_stock_page") }}
					</v-btn>
				</template>
			</common-table>
			<stock-filter-dialog v-model="filterDialog.visibility" :data="filterDialog.data" @done="filterDialog.done" />
			<new-stock-dialog v-model="newDialog.visibility" @saved="onNewStockSaved" />
		</template>
	</page-template>
</template>

<script>
import { mapGetters } from "vuex";
import PageTemplate from "../../templates/PageTemplate.vue";
import CommonTable from "../../partials/CommonTable.vue";
import NewStockDialog from "./dialogs/NewStockDialog.vue";
import StockFilterDialog from "./dialogs/StockFilterDialog.vue";
import remote from "../../../data/remote";
import uiMixin from "../../../store/interfaces/ui.mixin";
import { pagination as paginationMixin } from "../../mixins/utils.mixin";

export default {
	name: "Stocks",
	components: { PageTemplate, CommonTable, NewStockDialog, StockFilterDialog },
	mixins: [uiMixin, paginationMixin],
	data() {
		return {
			stocksWithNames: [],
			loading: true,
			filterDialog: {
				visibility: false,
				data: { text: null, warehouse: null, lotNo: null },
				show: () => (this.filterDialog.visibility = true),
				hide: () => (this.filterDialog.visibility = false),
				done: (d) => {
					this.filterDialog.data = d;
					this.tableOptions.page = 1;
					this.$router.push({ query: { ...d, page: 1 } });
					this.filterDialog.hide();
					this.loadItems();
				},
			},
			newDialog: { visibility: false },
			headers: [
				{ text: this.$t("lot_no"), value: "lotNo" },
				{ text: this.$t("product"), value: "productName" },
				{ text: this.$t("warehouse"), value: "warehouseName" },
				{ text: this.$t("total"), value: "totalQuantity" },
			],
		};
	},
	computed: {
		...mapGetters(["company"]),
		$lang() {
			return this.$i18n.locale;
		},
	},
	methods: {
		async loadItems() {
			this.loading = true;
			const page = this.tableOptions.page;
			const size = this.tableOptions.itemsPerPage;
			const sortKey = this.tableOptions.sortBy[0];
			const sortDir = this.tableOptions.sortDesc[0] ? "desc" : "asc";
			const { text, warehouse, lotNo } = this.filterDialog.data;
			remote.stocks.listView({
				filter: { text, warehouse, lotNo },
				lang: this.$i18n.locale,
				pager: { number: page, size },
				sorter: sortKey ? { property: sortKey, method: sortDir } : undefined,
				onSuccess: ({ items, pagination }) => {
					this.stocksWithNames = items;
					this.pagination = pagination;
					this.loading = false;
				},
				onFail: () => {
					this.loading = false;
				},
			});
		},
		stockAction(stock) {
			this.$router.push({ name: "stock", params: { id: stock.id } });
		},
		newStock() {
			this.newDialog.visibility = true;
		},
		onNewStockSaved() {
			this.newDialog.visibility = false;
			this.loadItems();
		},
		goToPublicAddress() {
			const url = this.$router.resolve({
				name: "publicStocks",
				params: { publicUrl: this.company.publicUrl },
			}).href;
			window.open(url, "_blank");
		},
	},
	created() {
		this.filterDialog.data.text = this.$route.query.text;
		this.filterDialog.data.warehouse = this.$route.query.warehouse;
		this.filterDialog.data.lotNo = this.$route.query.lotNo;
	},
};
</script>
